// #region imports

// --- Angular
import {
  Directive,
  Input,
  ElementRef,
  Renderer2,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

// #endregion

@Directive({
  selector: '[hsHighlightText]',
})
export class HighlightTextDirective implements OnChanges {
  @Input() searchText: string = '';
  @Input() text: string = '';

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges) {
    if (!this.searchText || !this.text) {
      this.renderer.setProperty(
        this.elementRef.nativeElement,
        'innerHTML',
        this.text
      );
      return;
    }

    this.renderer.setProperty(
      this.elementRef.nativeElement,
      'innerHTML',
      this._getFormattedText()
    );
  }

  private _getFormattedText(): string {
    if (this.searchText && this.text) {
      const startIndex = this.text
        .toLowerCase()
        .indexOf(this.searchText.toLowerCase());
      if (startIndex !== -1) {
        const matchingString = this.text.substr(
          startIndex,
          this.searchText.length
        );
        return this.text.replace(
          matchingString,
          `<mark class="text-dark fw-semibold">${matchingString}</mark>`
        );
      }
    }
    return this.text;
  }
}
